import DateTimeFormatHelper from '../../helpers/dateTimeFormatHelper'

type PropTypes = {
  design: { id: string, name: string, updated_at: string, thumbnail_url: string }
  dropdown?: React.ReactNode
}

const DesignListCard = ({ design, dropdown }: PropTypes) => {
  return (
    <div
      key={design.id}
      className="flex flex-row items-center gap-4"
      title={design.name}
    >
      <div className="flex flex-row items-center justify-between py-2.5 w-full gap-4">
        <div className="flex flex-row items-center col-span-7 gap-5">
          <img
            src={design.thumbnail_url}
            alt=""
            className="w-[88px] h-[50px] object-cover rounded border border-gray-400 shrink-0"
          />
          <div>
            <p className="text-sm leading-[16.8px] max-w-[180px] lg:max-w-md truncate">{design.name}</p>
            <p className="text-xs text-gray-600 leading-[16.8px] lg:hidden block">{`Edited ${DateTimeFormatHelper.toRelativeTimeAgo(design.updated_at)}`}</p>
          </div>
        </div>
        <p className="text-xs text-gray-600 leading-[16.8px] lg:flex hidden">{`Edited ${DateTimeFormatHelper.toRelativeTimeAgo(design.updated_at)}`}</p>
      </div>
      <div className="flex items-center justify-center">
        {dropdown}
      </div>
    </div>
  )
}

export default DesignListCard
